// src/components/tour/tours/common.jsx
// Pieces shared by every page tour.

import React from 'react';

/** Shared last step for every page: points at the "?" itself. */
export const replayStep = {
    target: '[data-tour="tour-help"]',
    title: "That's it!",
    content: <p>Tap this <b>?</b> anytime to replay the tour for the page you're on.</p>,
};
